export const hasNotification = () =>
  typeof window !== 'undefined' && 'Notification' in window;

export const getPermissionSafe = () =>
  hasNotification() ? window.Notification.permission : 'default';

export const requestPermissionSafe = async () => {
  if (!hasNotification()) return 'denied';
  try {
    return await window.Notification.requestPermission();
  } catch {
    return 'denied';
  }
};